export default __webpack_public_path__ + "static/media/photo--sm--4.564eddc1.jpg";